import gql from 'graphql-tag';

const GET_CART_DETECTION = gql`
  query detectCart($url: String!) {
    detectCart(url: $url)
  }
`;

export default GET_CART_DETECTION;
